import styled from 'styled-components';

export const TableWrapper = styled.div`
  margin-top: 20px;
`;
